import { useState } from "react";
import ProfileContainer from "../components/ProfileContainer";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const AgencyProfileWorkGallery = ({ items }) => {
    const [index, setIndex] = useState(-1);
    const images = items.map(i => ({ ...i, src: i.url }))

    const currentImage = images[index];
    const nextIndex = (index + 1) % images.length;
    const nextImage = images[nextIndex] || currentImage;
    const prevIndex = (index + images.length - 1) % images.length;
    const prevImage = images[prevIndex] || currentImage;

    const handleClick = (index, item) => setIndex(index);
    const handleClose = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);



    return (
        <div id="work-gallery" className="pt-2 pb-8">
            <ProfileContainer>
                <h4 className="textbold text-lg pb-6">Work Gallery {!!items.length && `(${items.length})`}</h4>

                {!items.length && (
                    <div className="py-8 text-center">
                        <p className="text-base">No Work Gallery Available</p>
                    </div>
                )}

                <Gallery
                    images={images}
                    onClick={handleClick}
                    enableImageSelection={false}
                />

                {!!currentImage && (
                    <Lightbox
                        mainSrc={currentImage.src}
                        imageTitle={currentImage.caption}
                        mainSrcThumbnail={currentImage.src}
                        nextSrc={nextImage.src}
                        nextSrcThumbnail={nextImage.src}
                        prevSrc={prevImage.src}
                        prevSrcThumbnail={prevImage.src}
                        onCloseRequest={handleClose}
                        onMovePrevRequest={handleMovePrev}
                        onMoveNextRequest={handleMoveNext}
                    />
                )}
            </ProfileContainer>
        </div>
    )
}

export default AgencyProfileWorkGallery;
